import { Link } from "react-router-dom";
import { allCategories, allSoftware, formatDownloads, getCategoryCount, sortSoftware } from "@/utils/software";

const ranking = sortSoftware(allSoftware, "downloads").slice(0, 5);

export default function HomeSidebar() {
  return (
    <aside className="flex w-full flex-col gap-5">
      <div className="card-surface p-5">
        <h3 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
          <i className="ri-apps-2-line text-primary-600" />
          软件分类导航
        </h3>
        <ul className="flex flex-col">
          {allCategories.map((cat) => (
            <li key={cat.id}>
              <Link
                to={`/category/${cat.id}`}
                className="flex items-center justify-between gap-2 rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                <span className="flex items-center gap-2">
                  <i className={`${cat.icon} text-primary-600`} />
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">{getCategoryCount(cat.id)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="card-surface p-5">
        <h3 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
          <i className="ri-trophy-line text-accent-500" />
          热门下载榜
        </h3>
        <ol className="flex flex-col gap-1">
          {ranking.map((item, idx) => (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                className="flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    idx < 3 ? "bg-primary-500 text-foreground-950" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {idx + 1}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">
                  {item.name}
                </span>
                <span className="shrink-0 text-xs text-foreground-500">
                  {formatDownloads(item.downloads)}
                </span>
              </Link>
            </li>
          ))}
        </ol>
        <Link
          to="/softwares"
          className="mt-3 flex items-center justify-center gap-1 rounded-md border border-background-300 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          查看全部软件 <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </aside>
  );
}